/* eslint-disable camelcase */
/* globals iapiLaunchClient, iapiSetCallout, iapiSetClientPlatform, iapiSetDeliveryPlatform,
iapiLoginUsernameExternalToken, iapiERR_OK */
import React, { useState, useEffect } from 'react';

const launch = (platform) => {
  const clientType = 'html_poker';
  const gameType = '';
  const clientMode = 'real';
  const windowName = platform === 'web' ? 'game-iframe' : '_self';
  const windowWidth = -1;
  const windowHeight = -1;
  return iapiLaunchClient(clientType, gameType, clientMode, windowName, windowWidth, windowHeight);
};

const isSameOriginReferrer = () => document.referrer.indexOf(location.origin) === 0;

const listenLogout = () => {
  window.addEventListener(
    'message',
    (e) => {
      if (e.data === 'logout') {
        window.location.assign(isSameOriginReferrer() ? document.referrer : '/download');
      }
    },
    false
  );
};

const useClient = ({ platform, username, externalToken, language }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const calloutLogin = (response) => {
    setLoading(false);

    if (response.errorCode) {
      setError(JSON.stringify(response, null, 2));
      return;
    }

    const result = launch(platform);
    if (result !== iapiERR_OK) {
      setError(`Launch error: ${result}`);
    }
  };

  useEffect(() => {
    listenLogout();

    iapiSetCallout('Login', calloutLogin);
    iapiSetClientPlatform(platform);
    iapiSetDeliveryPlatform('HTML5');
    iapiLoginUsernameExternalToken(username, externalToken, 1, language);
  }, []);

  return { loading, error };
};

const Client = (props) => {
  const { loading, error } = useClient(props);

  const pendingSpinner = () => (
    <div className="pending">
      <img src="/images/gameui/redstar-logo-red.svg" alt="Red Star Casino" />
      <div className="spinner" />
    </div>
  );

  const errorBlock = () => <div className="error">{error}</div>;

  const game = () => (
    <div className="game">
      <iframe title="game-iframe" id="game-iframe" src="about:blank" width="100%" height="100%" />
    </div>
  );

  return (
    <div id="playtech-web-client">
      {game()}
      {loading ? pendingSpinner() : errorBlock()}
    </div>
  );
};

const PlaytechWebClient = (props) => <Client {...props} />;

export default PlaytechWebClient;
/* eslint-enable camelcase */
